import { Object3D } from '@wonderlandengine/api';

export interface AvatarTrackingObjects {
    head: Object3D;
    leftHand: Object3D | null;
    rightHand: Object3D | null;
    rigged: boolean;
}

/** Keep the legacy contract first; recognize the imported Mayo humanoid separately. */
export function resolveAvatarTrackingObjects(root: Object3D): AvatarTrackingObjects {
    const head = root.findByNameRecursive('Head')[0];
    if (head) {
        return {
            head,
            leftHand: root.findByNameRecursive('LeftHand')[0] ?? null,
            rightHand: root.findByNameRecursive('RightHand')[0] ?? null,
            rigged: false,
        };
    }

    const riggedHead = root.findByNameRecursive('Avatar_Head')[0];
    const leftHand = root.findByNameRecursive('Avatar_LeftHand')[0];
    const rightHand = root.findByNameRecursive('Avatar_RightHand')[0];
    if (riggedHead && leftHand && rightHand) {
        return { head: riggedHead, leftHand, rightHand, rigged: true };
    }

    return {
        head: root,
        leftHand: root.findByNameRecursive('LeftHand')[0] ?? null,
        rightHand: root.findByNameRecursive('RightHand')[0] ?? null,
        rigged: false,
    };
}